<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 py-10 class="hidden-sm-and-down">
        <span style="color: #000000; font-family: poppinsbold; font-size: 25px"
          >Our Products</span
        >
      </v-flex>
      <v-flex xs12 pt-10 class="hidden-md-and-up">
        <span style="color: #000000; font-family: poppinsbold; font-size: 25px"
          >Our Products</span
        >
      </v-flex>
    </v-layout>
    <v-layout
      wrap
      justify-center
      px-0
      px-xs-0
      px-sm-10
      px-md-10
      px-lg-10
      px-xl-10
    >
      <v-flex xs12 sm12 pt-5>
        <v-layout wrap justify-space-between>
          <v-flex xs12 sm4 md3>
            <v-layout wrap justify-center>
              <v-flex
                xs12
                style="font-family: opensansbold"
                class="hidden-xs-only"
              >
                <v-autocomplete
                  solo
                  flat
                  class="rounded-lg custom-autocomplete"
                  :items="shops"
                  v-model="name" :search-input.sync="searchKey1"
                  item-text="shopname"
                  item-value="ecoshopId"
                  color="#003D29"
                  prepend-inner-icon="mdi-store"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs11 class="hidden-sm-and-up">
                <v-expansion-panels flat>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <span style="font-family: opensansbold; font-size: 16px"
                        >Filters</span
                      >
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card class="mx-auto" max-width="500" tile flat>
                        <v-flex xs12 text-left pt-2>
                          <v-list class="pa-0" style="color: #000000">
                            <v-list-group
                              v-for="item in items"
                              :key="item.title"
                              v-model="item.active"
                              no-action
                              class="pa-0"
                              :active-class="`transperant black--text`"
                              style="color: #000000"
                            >
                              <template v-slot:activator>
                                <v-list-item-content
                                  class="pa-0"
                                  style="
                                    font-family: opensanssemibold;
                                    color: #000000;
                                  "
                                >
                                  <v-list-item-title
                                    v-text="item.title"
                                  ></v-list-item-title>
                                </v-list-item-content>
                              </template>

                              <v-list-item
                                v-for="child in item.items"
                                :key="child.title"
                                style="color: #000000"
                                class="pa-0"
                              >
                                <v-list-item-content
                                  style="
                                    font-family: opensansregular;
                                    color: #000000;
                                  "
                                >
                                  <v-checkbox
                                    @change="checkValue === child.value"
                                    v-model="checkValue"
                                    color="black"
                                    :ripple="false"
                                    :value="child.value"
                                    :label="child.title"
                                    hide-details
                                  ></v-checkbox>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-group>
                          </v-list>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <v-list class="pa-0" style="color: #000000">
                            <v-list-group
                              v-for="cat in category"
                              :key="cat.title"
                              v-model="cat.active"
                              no-action
                              class="pa-0"
                              :active-class="`transperant black--text`"
                              style="color: #000000"
                            >
                              <template v-slot:activator>
                                <v-list-item-content
                                  class="pa-0"
                                  style="
                                    font-family: opensanssemibold;
                                    color: #000000;
                                  "
                                >
                                  <v-list-item-title
                                    v-text="cat.title"
                                  ></v-list-item-title>
                                </v-list-item-content>
                              </template>
                              <v-list-item
                                v-for="child in cat.items"
                                :key="child.title"
                                style="color: #000000"
                                class="pa-0"
                              >
                                <v-list-item-content
                                  style="
                                    font-family: opensansregular;
                                    color: #000000;
                                  "
                                >
                                  <v-checkbox
                                    @change="toggleCheck(child.value)"
                                    color="black"
                                    :ripple="false"
                                    :input-value="checkCategory === child.value"
                                    hide-details
                                    :label="child.title"
                                  ></v-checkbox>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-group>
                          </v-list>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <v-list class="pa-0" style="color: #000000">
                            <v-list-group
                              v-for="rate in ratings"
                              :key="rate.title"
                              v-model="rate.active"
                              no-action
                              class="pa-0"
                              :active-class="`transperant black--text`"
                              style="color: #000000"
                            >
                              <template v-slot:activator>
                                <v-list-item-content
                                  class="pa-0"
                                  style="
                                    font-family: opensanssemibold;
                                    color: #000000;
                                  "
                                >
                                  <v-list-item-title
                                    v-text="rate.title"
                                  ></v-list-item-title>
                                </v-list-item-content>
                              </template>

                              <v-list-item
                                v-for="child in rate.items"
                                :key="child.title"
                                style="color: #000000"
                                class="pa-0"
                              >
                                <v-list-item-content
                                  style="
                                    font-family: opensansregular;
                                    color: #000000;
                                  "
                                >
                                  <v-layout wrap>
                                    <v-flex xs1>
                                      <v-checkbox
                                        @change="toggleCheckRating(child.value)"
                                        color="black"
                                        :ripple="false"
                                        :input-value="rating === child.value"
                                        hide-details
                                      ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs11 pl-2>
                                      <v-rating
                                        hover
                                        length="5"
                                        size="20"
                                        readonly
                                        background-color="#C0BEBD"
                                        color="#F28F34"
                                        empty-icon="mdi-star"
                                        full-icon="mdi-star"
                                        v-model="child.value"
                                      ></v-rating>
                                    </v-flex>
                                  </v-layout>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-group>
                          </v-list>
                        </v-flex>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-flex>
              <v-flex xs12 class="hidden-xs-only">
                <v-card flat rounded="lg">
                  <v-layout wrap pa-5>
                    <v-flex xs12 text-left>
                      <span style="font-family: opensansbold; font-size: 25px"
                        >Filters</span
                      >
                    </v-flex>
                    <v-flex xs12 text-left pt-2>
                      <v-list class="pa-0" style="color: #000000">
                        <v-list-group
                          v-for="item in items"
                          :key="item.title"
                          v-model="item.active"
                          no-action
                          class="pa-0"
                          :active-class="`transperant black--text`"
                          style="color: #000000"
                        >
                          <template v-slot:activator>
                            <v-list-item-content
                              class="pa-0"
                              style="
                                font-family: opensanssemibold;
                                color: #000000;
                              "
                            >
                              <v-list-item-title
                                v-text="item.title"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </template>

                          <v-list-item
                            v-for="child in item.items"
                            :key="child.title"
                            style="color: #000000"
                            class="pa-0"
                          >
                            <v-list-item-content
                              style="
                                font-family: opensansregular;
                                color: #000000;
                              "
                            >
                              <v-checkbox
                                @change="checkValue === child.value"
                                v-model="checkValue"
                                color="black"
                                :ripple="false"
                                :value="child.value"
                                :label="child.title"
                                hide-details
                              ></v-checkbox>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-group>
                      </v-list>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <v-list class="pa-0" style="color: #000000">
                        <v-list-group
                          v-for="cat in category"
                          :key="cat.title"
                          v-model="cat.active"
                          no-action
                          class="pa-0"
                          :active-class="`transperant black--text`"
                          style="color: #000000"
                        >
                          <template v-slot:activator>
                            <v-list-item-content
                              class="pa-0"
                              style="
                                font-family: opensanssemibold;
                                color: #000000;
                              "
                            >
                              <v-list-item-title
                                v-text="cat.title"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </template>
                          <v-list-item
                            v-for="child in cat.items"
                            :key="child.title"
                            style="color: #000000"
                            class="pa-0"
                          >
                            <v-list-item-content
                              style="
                                font-family: opensansregular;
                                color: #000000;
                              "
                            >
                              <v-checkbox
                                @change="toggleCheck(child.value)"
                                color="black"
                                :ripple="false"
                                :input-value="checkCategory === child.value"
                                hide-details
                                :label="child.title"
                              ></v-checkbox>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-group>
                      </v-list>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <v-list class="pa-0" style="color: #000000">
                        <v-list-group
                          v-for="rate in ratings"
                          :key="rate.title"
                          v-model="rate.active"
                          no-action
                          class="pa-0"
                          :active-class="`transperant black--text`"
                          style="color: #000000"
                        >
                          <template v-slot:activator>
                            <v-list-item-content
                              class="pa-0"
                              style="
                                font-family: opensanssemibold;
                                color: #000000;
                              "
                            >
                              <v-list-item-title
                                v-text="rate.title"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </template>

                          <v-list-item
                            v-for="child in rate.items"
                            :key="child.title"
                            style="color: #000000"
                            class="pa-0"
                          >
                            <v-list-item-content
                              style="
                                font-family: opensansregular;
                                color: #000000;
                              "
                            >
                              <v-layout wrap>
                                <v-flex xs1>
                                  <v-checkbox
                                    @change="toggleCheckRating(child.value)"
                                    color="black"
                                    :ripple="false"
                                    :input-value="rating === child.value"
                                    hide-details
                                  ></v-checkbox>
                                </v-flex>
                                <v-flex xs11 pl-2>
                                  <v-rating
                                    hover
                                    length="5"
                                    size="20"
                                    background-color="#C0BEBD"
                                    color="#F28F34"
                                    readonly
                                    empty-icon="mdi-star"
                                    full-icon="mdi-star"
                                    v-model="child.value"
                                  ></v-rating>
                                </v-flex>
                              </v-layout>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-group>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex
                xs11
                py-3
                style="font-family: opensansbold"
                class="hidden-sm-and-up"
              >
                <v-autocomplete
                  solo
                  flat
                  class="rounded-lg inputlabel"
                  :items="shops"
                  v-model="name"
                  item-text="shopname"
                  item-value="ecoshopId"
                  :hide-details="true"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex
                class="hidden-sm-and-up"
                xs11
                sm4
                md3
                style="font-family: poppinssemibold"
              >
                <v-select
                  solo
                  flat
                  class="rounded-lg custom-select-down"
                  :items="filter"
                  v-model="filterType"
                >
                </v-select>
              </v-flex>
              <v-flex class="hidden-sm-and-up" xs11 sm4 md4>
                <v-text-field
                  placeholder="Search Product"
                  class="rounded-xl"
                  solo
                  dense
                  style="font-family: poppinssemibold"
                  flat
                  v-model="searchKey"
                  :hide-details="true"
                  append-icon="mdi-magnify"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 sm8 md9 pl-3 pt-2>
            <v-layout wrap justify-start>
              <v-flex
                class="hidden-xs-only"
                xs12
                sm4
                md3
                pl-0
                pl-xs-0
                pl-sm-2
                pl-md-2
                pl-lg-2
                pl-xl-0
                style="font-family: poppinssemibold"
              >
                <v-select
                  solo
                  flat
                  dense
                  class="rounded-lg custom-select"
                  :items="filter"
                  v-model="filterType"
                >
                </v-select>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex
                text-right
                class="hidden-xs-only"
                xs12
                sm6
                md4
                pr-2
                pl-0
                pl-xs-0
                pl-sm-2
                pl-md-2
                pl-lg-2
                pl-xl-0
              >
                <v-text-field
                  placeholder="Search Product"
                  class="rounded-xl"
                  solo
                  dense
                  style="font-family: poppinssemibold"
                  flat
                  v-model="searchKey"
                  :hide-details="true"
                  append-icon="mdi-magnify"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pt-2 v-if="product.length > 0">
                <v-layout wrap justify-start>
                  <v-flex
                    xs12
                    sm6
                    md4
                    px-3
                    pb-8
                    v-for="(list, l) in product"
                    :key="l"
                  >
                    <v-card elevation="0">
                      <v-layout wrap justify-center pb-8>
                        <v-flex xs12>
                          <v-layout wrap justify-center>
                            <!-- <v-flex
                                xs6
                                sm6
                                text-left
                                v-if="list.offerPercentage > 1"
                              >
                                <v-img
                                  height="30px"
                                  width="70px"
                                  src="./../../assets/icons/tag.png"
                                >
                                  <span
                                    style="
                                      color: #ffffff;
                                      font-size: 13px;
                                      font-family: opensanssemibold;
                                    "
                                  >
                                    &nbsp;
                                    {{ list.offerPercentage.toFixed() }} %</span
                                  >
                                </v-img>
                              </v-flex> -->

                            <v-flex xs12 pt-6>
                              <v-flex xs11 sm11 md11 pl-15 align-self-center>
                                <v-layout
                                  wrap
                                  justify-end
                                  align-center
                                  fill-height
                                >
                                  <v-flex xs2 sm3 md3 lg2 align-self-center>
                                    <v-layout
                                      wrap
                                      py-1
                                      @click="addWishlist(list)"
                                    >
                                      <v-flex
                                        style="cursor: pointer"
                                        v-if="list.isWishlist == true"
                                      >
                                        <v-icon size="20" color="red"
                                          >mdi-heart</v-icon
                                        >
                                      </v-flex>
                                      <v-flex style="cursor: pointer" v-else>
                                        <v-icon size="20"
                                          >mdi-heart-outline</v-icon
                                        >
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-img
                                contain
                                height="160px"
                                :src="mediaURL + list.image[0]"
                              ></v-img>
                              <!-- :src="mediaUURL + list.photos[0]" -->
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                    <v-layout wrap justify-start>
                      <v-flex xs12>
                        <router-link
                          :to="
                            '/productDetails?productName=' +
                            list.productName +
                            '&id=' +
                            list.productId
                          "
                        >
                          <v-layout wrap px-2>
                            <!-- <v-flex xs12>
                                <span
                                  style="
                                    color: #bcb4b4;
                                    font-family: poppinsmedium;
                                    font-size: 12px;
                                  "
                                  >{{ list.name }}</span
                                >
                              </v-flex> -->
                            <v-flex xs9 sm6 md8 text-left pt-2>
                              <span
                                style="
                                  color: #000000;
                                  font-family: poppinsmedium;
                                  font-size: 15px;
                                  text-transform: capitalize;
                                "
                                >{{ list.productName.slice(0, 15) }}</span
                              >
                              <span v-if="list.productName.length > 15">
                                ...
                              </span>
                            </v-flex>
                            <v-flex xs3 sm6 md4 pt-2 text-right>
                              <span
                                style="
                                  color: #000000;
                                  font-family: RobotoBold;
                                  font-size: 17px;
                                "
                              >
                                {{ list.productPrice }}</span
                              >
                            </v-flex>
                            <v-flex xs12 text-left>
                              <span
                                style="
                                  color: #000000;
                                  font-family: poppinsmedium;
                                  font-size: 14px;
                                "
                                >{{ list.productSize }} {{ list.unit }}</span
                              >
                            </v-flex>
                            <v-flex xs12 text-left>
                              <v-layout wrap justify-start>
                                <v-flex xs4 sm6 md8 lg4>
                                  <v-rating
                                    hover
                                    length="5"
                                    size="18"
                                    background-color="#F28F34"
                                    color="#F28F34"
                                    half-increments
                                    readonly
                                    v-model="list.productRating"
                                  ></v-rating>
                                </v-flex>
                                <v-flex xs4 sm6 md4 lg4 text-left>
                                  <span
                                    style="
                                      color: #2b2b2b;
                                      font-family: poppinslight;
                                      font-size: 12px;
                                    "
                                    >({{list.reviewCount}})</span
                                  >
                                </v-flex>
                                <v-flex
                                xs4 sm12 md12 lg4
                              text-end
                              v-if="list.stock === 'Out of Stock'"
                            >
                              <span
                                style="
                                  color: red;
                                  font-size: 13px;
                                  font-family: poppinsmedium;
                                "
                                >Out Of Stock
                              </span>
                            </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 text-left pt-3>
                              <v-btn 
                                v-if="list.isCart==false"
                                color="#1D9A50"
                                dark
                                elevation="0"
                                rounded
                                :to="
                                  '/productDetails?productName=' +
                                  list.productName +
                                  '&id=' +
                                  list.productId
                                "
                              >
                                <span
                                  style="
                                    font-family: opensansbold;
                                    text-transform: none;
                                    font-size: 13px;
                                    letter-spacing: 0px;
                                  "
                                >
                                  Add to Cart
                                </span>
                              </v-btn>
                            
                              <v-btn 
                                v-else
                                color="grey"
                                dark
                                elevation="0"
                                rounded
                              >
                                <span
                                  style="
                                    font-family: opensansbold;
                                    text-transform: none;
                                    font-size: 13px;
                                    letter-spacing: 0px;
                                  "
                                >
                                  In Cart
                                </span>
                              </v-btn>
                            </v-flex>
                            <!-- <v-flex xs6 sm6 text-left pt-3>
                              <v-btn
                                color="#1D9A50"
                                dark
                                elevation="0"
                                rounded
                                :to="
                                  '/productDetails?productName=' +
                                  list.productName +
                                  '&id=' +
                                  list.productId
                                "
                              >
                                <span
                                  style="
                                    font-family: opensansbold;
                                    text-transform: none;
                                    font-size: 13px;
                                    letter-spacing: 0px;
                                  "
                                  >Add to Cart</span
                                ></v-btn
                              >
                            </v-flex> -->
                          </v-layout>
                        </router-link>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center pt-2>
                  <v-flex xs12>
                    <div class="text-center pb-5" v-if="pages > 1">
                      <v-pagination
                        :length="pages"
                        :total-visible="7"
                        v-model="currentPage"
                        color="#30B868"
                        circle
                      ></v-pagination>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 v-else align-self-center pt-5>
                <span
                  style="
                    font-family: poppinsregular;
                    font-size: 25px;
                    color: #000000;
                    cursor: pointer;
                  "
                  >Oops! No Products Found</span
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      page: 1,
      currentPage: 1,
      pages: 0,
      limit: 16,
      catId: "",
      idCat: "",
      keyword: "",
      searchKey:"",
      name: "",
      searchKey1: "",
      filterType: "Relevence",
      shops: [],
      filter: ["Relevence"],
      lists: [
        {
          image: require("./../../assets/images/product1.png"),
          category: "Health",
          name: "Honey (Organic)",
          quantity: "500 Gm",
          price: "₹ 520",
          // price: "(₹ 620)",
        },
        {
          image: require("./../../assets/images/product2.png"),
          category: "Groceries ",
          name: "Pure Coconut Oil ",
          quantity: "500 ml",
          price: "₹ 250",
          // price: "(₹ 320)",
        },
        {
          image: require("./../../assets/images/product3.png"),
          category: "Personal Care",
          name: "Softening Creamy Soap Bar",
          quantity: "100 Gm",
          price: "₹ 120",
          // price: "(₹ 180)",
        },
        {
          image: require("./../../assets/images/product4.png"),
          name: "Sesame Oil",
          category: "Groceries ",
          quantity: "500 ml",
          price: "₹ 480",
          // price: "(₹ 560)",
        },
        {
          image: require("./../../assets/images/product5.png"),
          category: "Personal Care ",
          name: "Herbal Charcoal Soap",
          quantity: "100 Gm",
          price: "₹ 220",
          // price: "(₹ 280)",
        },
        {
          image: require("./../../assets/images/product1.png"),
          category: "Health",
          name: "Honey (Organic)",
          quantity: "500 Gm",
          price: "₹ 520",
          // price: "(₹ 620)",
        },
        {
          image: require("./../../assets/images/product2.png"),
          category: "Groceries ",
          name: "Pure Coconut Oil ",
          quantity: "500 ml",
          price: "₹ 250",
          // price: "(₹ 320)",
        },
        {
          image: require("./../../assets/images/product3.png"),
          category: "Personal Care",
          name: "Softening Creamy Soap Bar",
          quantity: "100 Gm",
          price: "₹ 120",
          // price: "(₹ 180)",
        },
      ],
      items: [
        {
          items: [
            { title: "In stock", value: "in", selected: false },
            { title: "Out of stock", value: "out", selected: false },
          ],
          title: "Availability",
          active: true, // Ensure this group is open by default
        },
      ],
      category: [
        {
          items: [
            { title: "All", value: "All", selected: false },
            { title: "Personal Care", value: "Personal Care", selected: false },
            { title: "Health", value: "Health", selected: false },
            { title: "Groceries", value: "Groceries", selected: false },
          ],
          title: "Category",
          active: true, // Ensure this group is open by default
        },
      ],
      ratings: [
        {
          items: [
            { title: 1, value: 1, selected: false },
            { title: 2, value: 2, selected: false },
            { title: 3, value: 3, selected: false },
            { title: 4, value: 4, selected: false },
            { title: 5, value: 5, selected: false },
          ],
          title: "Rating",
          active: true, // Ensure this group is open by default],
        },
      ],
      checkValue: "",
      rating: "",
      checkCategory: "",
      product: [],
    };
  },
  computed: {
    appLogin() {
      if (this.$store.state.isLoggedIn) return this.$store.state.isLoggedIn;
      else return null;
    },
    appUserId() {
      return this.$store.state.id;
    },
    UserId() {
      return this.$store.state.userId;
    },
  },
  watch: {
    currentPage() {
      this.getProducts();
      this.$store.commit("changeCurrentPage", this.currentPage);
    },
    searchKey() {
      this.currentPage = 1;
      this.getProducts();
    },
    searchKey1() {
      this.search = this.searchKey1;
      this.getShop();
    },
    checkValue() {
      this.getProducts();
    },
    rating() {
      this.getProducts();
    },
    name() {
      this.getProducts();
    },
    checkCategory() {
      this.getProducts();
    },
  },
  beforeMount() {
    this.getShop();
    if (this.shops) {
      const shopId = parseInt(this.$route.query.id);
      this.name = shopId;
    }

    if (this.$store.state.currentPage) {
      this.currentPage = this.$store.state.currentPage;
      this.getProducts();
    } else {
      this.getProducts();
    }
  },
  methods: {
    toggleCheck(value) {
      // Toggle checkCategory based on the value
      this.checkCategory = this.checkCategory === value ? null : value;
    },
    toggleCheckRating(value) {
      this.rating = this.rating === value ? null : value;
    },
    getSearch() {
      if (this.catId == "") {
        this.currentPage = 1;
        this.getProducts();
      } else {
        this.currentPage = 1;
        this.getProductsFilter(this.idCat);
      }
    },
    getShop() {
      this.appLoading = true;
      axios({
        url: "/ecoshop/list",
        method: "GET",
        // headers: {
        //   token: localStorage.getItem("token"),
        // },
        params: {
          searchKey: this.search,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.shops = response.data.data;
          this.shops.unshift({ shopname: "All", ecoshopId: "" });
          // this.name = this.$route.query.id;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getProducts() {
      // if(!this.name){
      //   var ecoshopId=this.$route.query.id
      // }
      // else{
      //   ecoshopId=this.name
      // }
      this.appLoading = true;
      axios({
        url: "/product/list",
        method: "POST",
        data: {
          id: localStorage.getItem("id"),
          guestId: localStorage.getItem("userId"),
          searchKey: this.searchKey,
          ecoshopId: this.name,
          stock: this.checkValue,
          productCategory: this.checkCategory,
          rating: this.rating,
          // limit: this.limit,
          // page: this.currentPage,
          // category: null,
          // keyword: this.keyword,
        },
        // headers: {
        //   token: localStorage.getItem("token"),
        // },
      })
        .then((response) => {
          this.appLoading = false;
          this.product = response.data.data;
          this.$store.commit("changeWishlist", response.data.wishListCount);
          this.catId = "";
          this.pages = Math.ceil(response.data.totalLength / this.limit);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getProductsFilter(id) {
      this.appLoading = true;
      this.currentPage = 1;
      // if(id){
      //   this.keyword=""
      // }
      axios({
        url: "/products",
        method: "POST",
        data: {
          sellerName: this.$route.query.sellerName,
          limit: this.limit,
          page: this.currentPage,
          category: id,
          keyword: this.keyword,
        },
        // headers: {
        //   token: localStorage.getItem("token"),
        // },
      })
        .then((response) => {
          this.appLoading = false;
          this.catId = id;
          this.product = response.data.data;
          this.pages = Math.ceil(response.data.totalLength / this.limit);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    addWishlist(item) {
      this.appLoading = true;

      axios({
        url: "/user/wishList/Add",
        method: "POST",

        data: {
          productId: item.productId,
          customerId: localStorage.getItem("id"),
          guestId: localStorage.getItem("userId"),
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.product = response.data.data;
          this.$store.commit("changeWishlist", response.data.wishListCount);
          this.getProducts();
          this.pages = Math.ceil(response.data.totalLength / this.limit);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.v-list-group__header.v-application .primary--text {
  color: black;
}
.v-list-item {
  padding: 0px;
}
.custom-select .v-select__slot {
  font-family: opensansbold; /* Replace with your preferred font-family */
  font-size: 14px; /* Replace with your preferred font-size */
}
.custom-select-down .v-select__slot {
  font-family: opensansbold; /* Replace with your preferred font-family */
  font-size: 16px; /* Replace with your preferred font-size */
}
.top-left-content {
  position: absolute;
  top: 20px;
  left: 0;
  padding: 5px;
  background-color: #ff7c03;
}
.custom-autocomplete .v-input__prepend-inner .v-icon {
  color: #056848; /* Change to your desired color */
}
.custom-autocomplete .v-input__control .v-input__slot input {
  font-size: 16px; /* Change to your desired font size */
  font-family: opensansbold; /* Replace with your preferred font-family */
}
</style>